import { gql } from '@apollo/client';

const SubscriptionInfoShared = gql`
  fragment SubscriptionInfoShared on Subscription {
    id
    name
    orderId
    order {
      id
      hexCode
    }
    description
    hexCode
    startedAt
    endedAt
    firstPaymentAt
    lastPaymentAt
    renewalAt
    endedAt
    state
    unitsPerInterval
    planInterval
    consecutiveFailures
    lastFailedAt
    reminder1SentAt
    reminder2SentAt
    reminder3SentAt
    needsCreditCard
    needsUpdatedCard
    pausedAt
    pauseDuration
    pauseEndAt
    subscriptionPrice
    product {
      id
      name
      price
      description
      productFeatures {
          id
          text
      }
    }
    patient {
      id
      firstName
      lastName
      retainerBank
    }
    account {
      id
      accountNumber
      users {
        id
        firstName
        lastName
        email
        phone
      }
    }
    createdAt
    updatedAt
  }
`;

export default SubscriptionInfoShared;
